<template>
  <v-footer absolute class="body-2">
    <v-row class="text-center">
      <v-col class="pa-0">
        <span>&copy; {{ year() }} Jiří Pazderník</span>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
  export default {
    name: "Footer",
    methods: {
      year () {
        let d = new Date();
        return d.getFullYear();
      }
    }
  }
</script>

<style scoped>
  a {
    color: white;
    text-decoration: none;
  }
</style>
